import { drmDeleteTableData } from "../../service/drmDeleteTableData";
import {
  setDeleteDrmTableDataSuccess,
  setDeleteDrmTableDataFailure,
} from "../reducers/drmtDeleteTableDataSlice";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerDeleteDrmTableData(action) {
  const { payload } = action;

  try {
    const response = yield call(drmDeleteTableData, [
      payload.deleteData,
      payload.tableName,
      payload.controller,
    ]);

    const detailsRoot = response?.data?.details;
    const detailsData = detailsRoot?.data;
    const details =
      (detailsData && typeof detailsData === "object" ? detailsData : detailsRoot) ||
      {};

    const toArray = (records) => (Array.isArray(records) ? records : []);
    const errorRecords = toArray(details?.errorRecords);
    const successRecords = toArray(details?.successRecords);

    const formatRecordMessages = (records = [], label) => {
      if (!records.length) {
        return "";
      }

      const formattedRows = records
        .map((record, index) => {
          const sagaId = record?.sagaId ?? `Row-${index + 1}`;
          const message = record?.message ?? "No message provided";
          return `${index + 1}. Saga ID: ${sagaId} - ${message}`;
        })
        .join("\n");

      return label ? `${label}:\n${formattedRows}` : formattedRows;
    };

    const responseMessage = response?.data?.message;
    const messageSegments = [
      formatRecordMessages(errorRecords, "Failed deletions"),
      formatRecordMessages(successRecords, "Successful deletions"),
      //responseMessage,
    ].filter(Boolean);

    const combinedPayload = messageSegments.join("\n\n") || responseMessage;

    yield put(setDeleteDrmTableDataSuccess(combinedPayload));
  } catch (error) {
    yield put(setDeleteDrmTableDataFailure(error.toString()));
  }
}

function* drmDeleteTableDataSaga() {
  yield takeLatest(
    "deleteDrmtTableData/setDeleteDrmTableData",
    workerDeleteDrmTableData
  );
}

export default drmDeleteTableDataSaga;
